/**
 * Block 12 PR-Hotfix-2B Phase B4 Step 8 — Витрина formulas helpers.
 *
 * Pure functions для compound area/cost calculation. Extracted из
 * `VitrineCompound.tsx` чтобы (a) `computeTotal` мог переиспользовать ту же
 * формулу при Step 9 wire'е, (b) сохранить single-export discipline в
 * VitrineCompound.tsx (react-refresh/only-export-components).
 *
 * Формулы (per прототип 2.12.2:472-473, 484):
 *   - `areaM2 = (length × height) / 1_000_000` (мм² → м²)
 *   - `cost = areaM2 × pricePerM2`
 *
 * Reference: Hotfix-2B TZ §5 Step 8.
 */

/** Площадь Витрины в м² из длины×высоты в мм. Returns 0 если любой из L/H = 0. */
export function computeVitrineAreaM2(lengthMm: number, heightMm: number): number {
  return (lengthMm * heightMm) / 1_000_000;
}

/** Стоимость Витрины = area × pricePerM2. */
export function computeVitrineCost(lengthMm: number, heightMm: number, pricePerM2: number): number {
  return computeVitrineAreaM2(lengthMm, heightMm) * pricePerM2;
}
